import { api } from '../../lib/api-client';

/**
 * Acciones del cliente sobre talents (§4.5 — SW-502).
 * Discriminator wire: 'interested' | 'not_interested'.
 */
export type TalentActionType = 'interested' | 'not_interested';

export type TalentActionItem = {
  authorEmail: string;
  authorFullName: string | null;
  type: TalentActionType;
  createdOn: string;
  updatedOn: string | null;
};

export type ListActionsResponse = {
  items: TalentActionItem[];
};

export type SetActionResponse = {
  type: TalentActionType;
  alreadyRegistered: boolean;
};

export type ListActionsParams = {
  shortlistPublicKey: string;
  talentPublicKey: string;
};

export type SetActionParams = ListActionsParams & {
  type: TalentActionType;
};

export async function listTalentActions(
  params: ListActionsParams,
): Promise<ListActionsResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/actions`;
  return api.get<ListActionsResponse>(url);
}

export async function setTalentAction(
  params: SetActionParams,
): Promise<SetActionResponse> {
  const url =
    `/api/client/shortlists/${params.shortlistPublicKey}` +
    `/talents/${params.talentPublicKey}/actions`;
  return api.post<SetActionResponse>(url, { type: params.type });
}
